export default __webpack_public_path__ + "static/media/muybuenalumno.f1757411.jpg";